export default "/backend/static/media/synchronizing.67e19dc6.gif";